import { render } from "./Settlement.vue?vue&type=template&id=c95e1bc4&scoped=true"
import script from "./Settlement.vue?vue&type=script&lang=js"
export * from "./Settlement.vue?vue&type=script&lang=js"

import "./Settlement.vue?vue&type=style&index=0&id=c95e1bc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c95e1bc4"]])

export default __exports__